/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Appinfo_DescriptionInputs */

const en_admin_settings_groups_appinfo_description = /** @type {(inputs: Admin_Settings_Groups_Appinfo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic application settings`)
};

const zh_admin_settings_groups_appinfo_description = /** @type {(inputs: Admin_Settings_Groups_Appinfo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本应用设置`)
};

/**
* | output |
* | --- |
* | "Basic application settings" |
*
* @param {Admin_Settings_Groups_Appinfo_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_appinfo_description = /** @type {((inputs?: Admin_Settings_Groups_Appinfo_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Appinfo_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_appinfo_description(inputs)
	return zh_admin_settings_groups_appinfo_description(inputs)
});
export { admin_settings_groups_appinfo_description as "admin.settings.groups.appinfo.description" }